import React from 'react';
import { FiClock } from 'react-icons/fi';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import DeviceScheduleView from '@/components/shared/DeviceScheduleView';
import { DeviceSelector } from '@/components/shared/DeviceSelectorNew';
import useGlobalDeviceSelector from '@/hooks/useGlobalDeviceSelector';

const ScheduleTimelinePage: React.FC = () => {
  const { mode } = useSelector((state: RootState) => state.theme);
  const { selectedDeviceId, onDeviceChange } = useGlobalDeviceSelector();

  return (
    <div className="page-container relative h-full flex flex-auto flex-col px-4 sm:px-6 md:px-8 py-2 pb-0 text-gray-900 dark:text-gray-100">
      <div className="flex flex-col gap-3 h-full w-full" style={{ marginBottom: '-1px' }}>
        <div className="flex items-center justify-between">
          <div>
            <div className="flex items-center gap-2">
              <FiClock className="text-primary-500 text-xl" />
              <h2 className={classNames(
                "text-lg font-semibold",
                {
                  'text-gray-900': mode === 'light',
                  'text-gray-200': mode === 'dark'
                }
              )}>Schedule Timeline</h2>
            </div>
            <p className={classNames(
              "mt-1 text-sm",
              {
                'text-gray-500': mode === 'light',
                'text-gray-400': mode === 'dark'
              }
            )}>
              Visualize device schedules across the week
            </p>
          </div>
          <div className="flex items-center gap-2 mr-16">
            <div style={{ minWidth: '200px' }}>
              <DeviceSelector 
                onDeviceChange={onDeviceChange}
                selectedDeviceId={selectedDeviceId}
              />
            </div>
          </div>
        </div>
        <div className="h-0.5 bg-gray-200 dark:bg-gray-700 my-2"></div>

        {/* Schedule View Component */}
        <DeviceScheduleView 
          title="Weekly Device Operation Schedule"
          selectedDeviceId={selectedDeviceId}
        />
      </div>
    </div>
  );
};

export default ScheduleTimelinePage;